import React from 'react';
import { maskMoney, maskRichText, maskCapitalizeFirstLetter } from '../../masks';

class MenuDishView extends React.Component {
  render() {
    const { dish } = this.props;
    return (
      <tr className="table__tr--underline">
        <td className="table__td menu-dish__view menu-dish__view--name">
          <p className="p">
            {dish.name || '-'}{' '}
            <span className="p--em p--new-line">{dish.child_name || ''}</span>
          </p>
        </td>
        <td className="table__td menu-dish__view menu-dish__view--ingredients">
          {maskRichText(dish.public_ingredients || '<p>-</p>')}
        </td>
        <td className="table__td menu-dish__view menu-dish__view--price">
          <p className="p">{maskMoney(dish.price_cents) || '-'}</p>
        </td>
        <td className="table__td menu-dish__view menu-dish__view--diet">
          <p className="p">{this.renderDiet(dish.dietary_preference_tags)}</p>
        </td>
        <td className="table__td menu-dish__view menu-dish__view--allergens">
          <p className="p">{this.renderAllergens(dish.allergens)}</p>
        </td>
        <td className="table__td menu-dish__view menu-dish__view--allergens">
          <p className="p"> {maskCapitalizeFirstLetter(dish.complexity)} </p>
        </td>
      </tr>
    );
  }

  renderDiet(diets) {
    return diets.map(diet => diet.abbreviation).join(', ') || '-';
  }

  renderAllergens(allergens) {
    return allergens.map(allergen => allergen.tag).join(', ') || '-';
  }
}

export default MenuDishView;



// WEBPACK FOOTER //
// ./src/components/menu/MenuDishView.js